import axios from "axios";
import { enqueue } from "@/lib/offlineQueue";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "fender_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

/**
 * offlineSafe(method, url, body): Executes network mutation when online.
 * When offline, queues in IndexedDB and returns an "optimistic" response marker.
 * Use for non-critical, retry-safe backend mutations (task updates, patches).
 */
export const offlineSafe = async (method, url, body, label) => {
  if (!navigator.onLine) {
    await enqueue({ method, url, body, label });
    return { _queued: true };
  }
  try {
    const resp = await api.request({ method, url, data: body });
    return resp.data;
  } catch (e) {
    // Network failure (no response) — swallow the error, queue for retry.
    // We deliberately do NOT re-throw so React error overlays don't pop up
    // during simulated / real offline sessions.
    if (!e.response) {
      await enqueue({ method, url, body, label });
      return { _queued: true, _reason: e.message };
    }
    throw e;
  }
};

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(d);
};

export const money = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "-";
  return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Number(n));
};

export const fmtDate = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch (e) {
    return s;
  }
};

export const fmtDateTime = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleString("en-IN", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch (e) {
    return s;
  }
};
